import React, { useEffect, useState } from "react";
import BookingTemplateOverviewTable from "./designOverview";
import SearchForm from "../../component/search-form";
import AddBookingNameModal from "./addbookingname";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BackButtonWindow from "../../component/Alert/BackButtonWindow";
import { CLEAR_COMPONENT_GRID_LAYOUT_DATA, CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY } from "../../redux/constants";
import { sanitizeInput } from "../../utils";

const Design = (props) => {
  // Creating state to store search value
  const [searchText, setSearchText] = useState();
  const [addbooking, setAddBooking] = useState(false);

  const location = useLocation();
  
  const { state } = location;
  const { tempPageName, path } = useSelector((state) => state.tempWindowsData);
  const dispatch = useDispatch();


  useEffect(() => {
    if (state !== null) {
      setAddBooking(true);
    }
  }, [state]);

  useEffect(() => {
    dispatch({ type: CLEAR_COMPONENT_GRID_LAYOUT_DATA });
    dispatch({type: CLEAR_TODO_DATA_FOR_UPDATE_INVENTORY});
  }, []);

  return (
    <>
      {path !== "" && tempPageName !== "" && (
        <BackButtonWindow
          backButtonName={tempPageName}
          title="Completed creating component?"
          path={path}
        />
      )}
      <div className="mt-4 sm:mx-6 lg:mx-8">
        <div className="space-y-2">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
            <div className="space-x-4 flex items-center">
              <h4 className="text-xl leading-5 font-bold tracking-tight">
                Template List
              </h4>
              <SearchForm
                placeholder="Search"
                value={searchText}
                onChange={(e) => {
                  const value = sanitizeInput(e.target.value);
                  setSearchText(value);
                }}
              />
            </div>
            <div className="space-x-4 flex items-center justify-end">
              <button
                className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
                onClick={() => {
                  setAddBooking(true);
                }}
              >
                <span className={`fas fa-plus mr-2`}></span>
                Create Booking Template
              </button>
            </div>
          </div>
          <BookingTemplateOverviewTable
            searchText={searchText}
          />
        </div>
        <AddBookingNameModal
          modalOpen={addbooking}
          setModalOpen={setAddBooking}
        />
      </div>
    </>
  );
};
Design.auth = { path: "/booking/design/overview", role: "super-admin admin" };
export default Design;
